import { styled } from 'styled-components';

export const StyledPageContainer = styled.div`
  position: relative;

  display: flex;
  gap: 40px;
  height: 100%;
  box-sizing: border-box;
  padding: 40px 20px;
`;
